import React, { PureComponent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import classnames from 'classnames';
import LocalizedNoIndexLink from 'components/LocalizedNoIndexLink';
import AgendaPopoverContainer from './AgendaPopoverContainer';
import FormatUtils from 'utils/FormatUtils';
import { Filter } from 'model/Filters';
import { analyticsTrack } from 'utils/analytics';
import parseISO from 'date-fns/parseISO';

const CSS = require('./AgendaPopoverTrigger.less');

interface AgendaPopoverTriggerProps {
  filters: {
    activeFilters: Filter[];
  };
  isMobile: boolean;
}

interface AgendaPopoverTriggerState {
  show: boolean;
}

class AgendaPopoverTrigger extends PureComponent<AgendaPopoverTriggerProps & RouteComponentProps<{}>, AgendaPopoverTriggerState> {

  state = {
    show: false,
  };

  togglePopover = () => {
    if (!this.state.show) {
      analyticsTrack(
        { type: 'click', subject: `open filter`, value: { filterCategory: 'date' }, valueString: 'date' },
        { category: 'Search page', action: 'click', label: 'Filter date' }
      );
    }
    this.setState({ show: !this.state.show });
  };

  closePopover = (callback, source) => {
    this.setState({ show: false }, callback);
  };

  renderPopover() {
    if (this.state.show) {
      const dateFrom = this.props.filters.activeFilters.find(filter => filter.uid === 'date.from')?.value;
      const dateTo = this.props.filters.activeFilters.find(filter => filter.uid === 'date.to')?.value;

      return (
        <AgendaPopoverContainer
          initialDateFrom={dateFrom ? parseISO(dateFrom) : null}
          initialDateTo={dateTo ? parseISO(dateTo) : null}
          onClose={this.closePopover}
        />
      );
    }

    return null;
  }

  render() {
    const classes = classnames(CSS.FilterButton, {
      [CSS.FilterButtonHasValue]: this.props.filters.activeFilters.some(filter => filter.uid === 'date.from' && filter.value),
    });

    return (
      <div>
        {
          this.props.isMobile ?
            <LocalizedNoIndexLink
              className={classes}
              to={{ pathname: '/filter/date/', state: { modal: true } }}
            >
              {FormatUtils.getDateText(this.props.filters)}
            </LocalizedNoIndexLink> :
            <button
              className={classes}
              onClick={this.togglePopover}
            >
              {FormatUtils.getDateText(this.props.filters)}
            </button>
        }
        {this.renderPopover()}
      </div>
    );
  }
}

export default withRouter(AgendaPopoverTrigger);
